<template>
  <VSkeletonLoader
    v-if="!slots.default"
    :type="props.structure"
    :data-cy="props.dataCy"
    :width="props.width"
  />

  <div
    v-else
    class="w-full gradient"
    :data-cy="props.dataCy"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { VueSlots } from "@/src/shared/types/slot";
import { useSlots } from "vue";

interface Props {
  structure?: string;
  width?: string;
  dataCy?: string;
}

const props = withDefaults(defineProps<Props>(), {
  structure: "article",
  width: "",
  dataCy: "skeleton-loader",
});
const slots = useSlots() as VueSlots<["default"]>;
</script>
